import { format } from 'date-fns';
import { ProductAssignmentSubmitPayload } from 'src/models/ProductAssignment';
import { FormValues, PRODUCT_ID_WITH_ENTRY_RULES } from './Form/formConstants';

export type { ProductAssignmentSubmitPayload };

/** Solo producto 8 usa tipo de ingreso; el API espera free vs paid (formulario: pago/free/cooldown). */
const typePackageFromEntry = (entryType: string, productId: string): 'free' | 'paid' => {
    if (productId !== PRODUCT_ID_WITH_ENTRY_RULES) {
        return 'paid';
    }
    return entryType === 'free' ? 'free' : 'paid';
};

const ymd = (d: Date) => format(d, 'yyyy-MM-dd');

export function buildProductAssignmentPayload(
    values: FormValues,
    profileEmail: string,
): ProductAssignmentSubmitPayload {
    const isFreeWithLeads =
        values.product_id === PRODUCT_ID_WITH_ENTRY_RULES && values.entry_type === 'free';
    const leadsNum = Number(String(values.allowed_leads ?? '').trim());
    const _allowed_deliveries =
        isFreeWithLeads && Number.isFinite(leadsNum) && leadsNum >= 1 ? leadsNum : null;
    const allowed_deliveries = values.entry_type === 'cooldown' ? 0 : _allowed_deliveries;
    const payload = {
        email: values.email.trim(),
        cart_product_id: Number(values.product_id),
        reason: 'admin_grant',
        type_package: typePackageFromEntry(values.entry_type, values.product_id),
        allowed_deliveries,
        period_start: ymd(values.date_start),
        period_end: ymd(values.date_end),
        admin_customer_email: (profileEmail ?? '').trim(),
    };

    return payload as ProductAssignmentSubmitPayload;
}
